import { Link } from "react-router-dom";

export default function AnnouncementBar() {
  return (
    <div className="announce-bar" data-testid="announce-bar">
      <div className="wrap announce-inner">
        <span className="announce-tag">Press release</span>
        <span className="announce-text">
          U.S. patent granted for our machine-learning technology to diagnose and evaluate pain disorders.
        </span>
        <Link to="/tactile-health" className="announce-link" data-testid="announce-readmore">
          Read more
        </Link>
      </div>
    </div>
  );
}
